<template>
  <div class="main_box">
    <div v-if="walletLoading">
      {{ $t("enum.loading") }}
    </div>
    <div v-else>
      <div v-if="ifwallet == 1">
        <!-- 信息 -->
        <div class="walletMsg">
          <div>
            <div class="walletTitle"><b>{{ $t("enum.accountBalance") }}</b></div>
            <div class="msg">
              <div class="balance">
                {{ walletInfo.Currency }}
                <b>{{ walletInfo.AvailableAmount > 0 ? $store.getters.thousandAndDecimal(walletInfo.AvailableAmount) : walletInfo.AvailableAmount }}</b>
              </div>
              <div class="operate">
                <div @click="operate(0)" class="takeCash">{{ $t("enum.takeCash") }}</div>
                <!-- <div>
                <el-popover width="260" popper-class="userHover" placement="bottom-start" trigger="hover">
                  <div>
                    <div class="userMsg">
                      <div class="bankName">{{ walletInfo.BankName ? walletInfo.BankName : '-' }}</div>
                      <div>{{ walletInfo.Name }}</div>
                    </div>
                    <div class="cardNumber">
                      {{ walletInfo.BankNo ? walletInfo['BankNo'].replace(/\s/g, '').replace(/[^\d]/g, '').replace(/(\d{4})(?=\d)/g, '$1 ') : '-' }}
                    </div>
                  </div>
                  <div slot="reference">银行卡信息</div>
                </el-popover>
              </div> -->
              </div>
            </div>
            <!-- <div class="walletFreeze" v-if="walletInfo.FreezeAmount > 0">
              {{ $t("enum.freezeAmount") }}
              {{ walletInfo.Currency }}
              {{ $store.getters.thousandAndDecimal(walletInfo.FreezeAmount) }}
            </div> -->
          </div>
        </div>
        <!-- 筛选条件 -->
        <div class="walletSortBox">
          <div class="billTitle">{{ $t("enum.myBill") }}
            <i slot="reference" class="icon_dl el-icon-download" @click="downloadBill"></i>
          </div>
          <!-- 条件 -->
          <div class="sortBox">
            <!-- <el-dropdown class="bo_block" v-on:command="filterType">
              <span class="el-dropdown-link filter-type">
                {{ typeLabel }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(obj, k) in typeList" :key="k" :disabled="obj.label == typeLabel ? true : false" :command="obj">{{ obj.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <div class="bo_block" @click="operate('date')"><span>{{ form.BeginDate }} {{ $t("enum.dateTo") }} {{ form.EndDate }}</span><i class="el-icon-arrow-down el-icon--right"></i></div>
            <el-dropdown class="bo_block" v-on:command="filterList">
              <span class="el-dropdown-link">
                {{ selectLabel }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(obj, k) in selectList" :key="k" :disabled="obj.label == selectLabel ? true : false" :command="obj">{{ obj.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- 分页 -->
        <!-- <el-pagination class="list_pagination" background @current-change="changePagination" :current-page.sync="form.PageIndex" :page-size="form.PageSize" layout="prev, pager, next" :total="TotalCount" v-if="TotalCount > 0">
        </el-pagination> -->
        <list-pagination class="list_pagination" v-if="TotalCount > 0" ref="Pagination" :total="TotalCount" @getData="getData" :PageSize="form.PageSize" :ifF_end="true" />
        <!-- 列表 -->
        <div class="walletList" v-for="item in walletHistory" :key="item._id">
          <div :class="['walletItem', item.BusinessType == 1 ? 'link-to' : '']" @click="linkTo(item)">
            <div class="transferLeft">
              <div class="transferMsg">{{ item.Title }}</div>
              <!-- BusinessType==4提现  && item.Status == 'Success'-->
              <!-- <div class="transferCervice" v-if="item.BusinessType == 4">
                {{ $t("enum.feeAmount") }}: {{ walletInfo.Currency }} {{ item.FeeAmount }}
              </div> -->
              <div class="transferCervice" v-if="item.BusinessType == 4">{{ item.Status }}</div>
              <div class="transferTime">
                <!-- {{ item.CreateDate }} -->
                {{ item.CreateDate ? $store.getters.getTime(item.CreateDate, $store.state.lang.indexOf("zh") > -1 ? 8 : -8, '', $store.state.lang.indexOf("zh") > -1 ? '' : 'MMM DD, YYYY HH:mm') : '' }}
              </div>
            </div>
            <div class="transferPrice" v-if="item.BusinessType != 4">
              {{ walletInfo.Currency }} {{ $store.getters.thousandAndDecimal(item.RealAmount) }}
            </div>
            <div class="transferPrice" v-else>
              {{ walletInfo.Currency }}&nbsp;&nbsp;- {{ $store.getters.thousandAndDecimal(item.BusinessAmount) }}
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <!-- <el-pagination v-if="TotalCount > 0 && walletHistory.length > 8" class="list_pagination" background @current-change="changePagination" :current-page.sync="form.PageIndex" :page-size="form.PageSize" layout="prev, pager, next" :total="TotalCount">
        </el-pagination> -->
      </div>
      <!-- 没开通钱包 -->
      <div v-else class="ifWallet">
        尚未开通钱包
        <!-- <span v-if="ifopen != ''" style="color: #999;">（{{ ifopen }}）</span>，<a :href="url" target="_blank"><span class="grant">去开通</span></a> -->
      </div>
    </div>

    <!-- 提现/转账 -->
    <wallet-operate v-if="walletDialog" :walletDialog="walletDialog" :type="type" :walletInfo="walletInfo" @closeDialog="closeDialog" />
    <!-- 日期控件 -->
    <wallet-date-picker ref="WDatePicker" :dateDialog="dateDialog" :beginDate="form.beginDate" :endDate="form.endDate" :fType="fType" @closeDialog="closeDialog"></wallet-date-picker>
  </div>
</template>
<script>
import WalletOperate from "@/components/dialog/wallet-operate";
import WalletDatePicker from "@/components/dialog/wallet-date-picker";
import ListPagination from '@/components/listpagination'
import md5 from "js-md5";
export default {
  components: { WalletOperate, WalletDatePicker, ListPagination },
  data() {
    return {
      loading: false,
      walletLoading: false,
      walletDialog: false,// 是否打开弹层【提现、转账】
      dateDialog: false,// 是否打开弹层【日期选择】
      type: 0,// 弹窗类型
      sort: 0,
      ifwallet: 0,// 是否开通
      ifopen: '',// 是否开通钱包msg
      maxStateDate: '2020-01-01',//账单最大起始日期
      date: [],//默认时间范围
      url: '',// 开通钱包地址
      walletInfo: {},//钱包相关信息
      amount: 0,// 金额
      walletAccounts: {},// 转账账户
      walletHistory: [],// 钱包历史
      TotalCount: 0,// 总数
      loading: false,
      ifChoose: false,
      typeLabel: this.$t("enum.withinSixMonths"),//账单筛选范围
      fType: 1,//账单筛选范围类型
      typeList: [
        ////账单筛选范围：近6个月内，6个月前
        {
          label: this.$t("enum.withinSixMonths"), val: 1
        }, {
          label: this.$t("enum.sixMonthsAgo"), val: 2,
        }],
      selectLabel: this.$t("enum.all"),
      selectList: [
        //Settlement = 1,转出 = 2,转入 = 3,Payout = 4,返利 = 5
        { label: this.$t("enum.all"), val: 0 },
        { label: this.$t("enum.settled"), val: 1, },
        // { label: "转出", val: 2, },
        // { label: "转入", val: 3, },
        { label: this.$t("enum.withdrawn"), val: 4 },
        // { label: "返利", val: 5, }
      ],
      pageSizeMax: 20,
      form: {
        BeginDate: '',// 开始时间
        BusinessType: 0,//交易类型
        EndDate: '',// 结束时间
        MemberId: this.$store.state.UserInfo.MappingUserId,
        PageIndex: 1,
        PageSize: 20,
      }
    }
  },
  watch: {
    FormData: {
      handler(fd) {
        // console.log('watch:', fd);
      },
      deep: true,
    },
  },
  created() {

    console.log("created this.$route", this.$route);
  },
  mounted() {
    let that = this;
    var toDay = new Date();
    var sDate = new Date(toDay.getTime() - 24 * 60 * 60 * 1000 * 30);//起始时间当天前30天
    var eDate = new Date(toDay.getTime());//结束时间为当天， - 24 * 60 * 60 * 1000(减24为昨天)
    var _date = [new Date(sDate), new Date(eDate)];
    that.date = _date;
    that.$refs.WDatePicker.date = _date;
    that.$set(that.form, 'BeginDate', that.$store.getters.getDateTime("yyyy-MM-dd", sDate));
    that.$set(that.form, 'EndDate', that.$store.getters.getDateTime("yyyy-MM-dd", eDate));
    this.$nextTick(() => {
      this.getData('','','GetAccountInfo');
      this.getData('','','GetRecordByPage');
    });
  },
  methods: {
    getData(PageIndex, PageSize,type) {
      let that = this;
      if (PageIndex && PageSize) { that.form.PageIndex = PageIndex; that.form.PageSize = PageSize; }
      switch (type) {
        case 'GetAccountInfo':
          that.walletLoading = true;
          that.$post('GetAccountInfo', {
            MemberId: that.$store.state.UserInfo.MappingUserId
          }, 'WalletApi')
            .then((res) => {
              that.walletLoading = false;
              if (res.Result) {
                const _data = res.Data;
                that.ifwallet = _data.IsEffective;
                that.walletInfo = res.Data;
                that.walletAccounts = _data.TransferAccounts;
                that.amount = _data.AvailableAmount;
                // var _maxStateDate = res.data.MaxStartDate;
                // that.maxStateDate = _maxStateDate;
                // that.$refs.WDatePicker.maxStateDate = _maxStateDate;
                console.log("walletInfo", that.walletInfo)
              } else {
                // that.$message.error('Login failed');
              }
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case 'GetRecordByPage':
          // console.log("===GetRecordByPage===", that.form)
          let _form = that.form;
          if (_form.BusinessType == 0) {
            _form = {
              BeginDate: _form.BeginDate,
              EndDate: _form.EndDate,
              MemberId: _form.MemberId,
              PageIndex: _form.PageIndex,
              PageSize: _form.PageSize,
            }
          }
          that.$post('GetRecordByPage', _form, 'WalletApi')
            .then((res) => {
              if (res.Result) {
                that.walletHistory = res.Data;
                that.TotalCount = res.Count;
              } else {
                // that.$message.error('Login failed');
              }
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        default:
          // 分页组件调用的方法
          this.getData('','','GetRecordByPage');
          break;
      }
    },
    linkTo(obj) {
      if (obj.BusinessType == 1) {
        this.$router.push(`/orders/detail?id=${obj.OrderId}`)
      }
    },
    // 下载
    downloadBill() {
      var that = this;
      var form = this.form;
      var GATEWAY = process.env.VUE_APP_GATEWAY;
      var WalletLink = process.env.VUE_APP_WALLET;
      if (process.env.VUE_APP_MIDDLEWARE === 'gateway') {
        WalletLink = `${GATEWAY}/wallet`
      }
      var api = WalletLink + '/api/Wallet/GetRecordByMemberForExport';
      var pms = `BeginDate=${form.BeginDate}${form.BusinessType ? `&BusinessType=${form.BusinessType}` : ``}&EndDate=${form.EndDate}&MemberId=${form.MemberId}`;
      var parm = `?${pms}&Authorization=${md5(pms + that.$store.state.walletKey)}`;
      var dLink = api + parm;
      console.log("downloadBill:", pms)
      window.open(dLink);
    },
    // 千分位
    Amount(val) {
      var amount = parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      return amount
    },
    //分页返回事件
    changePagination(val) {
      console.log("changePagination", val)
      this.$set(this.form, 'PageIndex', val);
      this.getData('','','GetRecordByPage');
    },
    handleSizeChange(val) {
      this.$set(this.form, 'PageSize', val);
      console.log(`每页 ${val} 条`);
      this.getData('','','GetRecordByPage');
    },
    // 打开/关闭弹框
    operate(val) {
      if (val == 'date') {
        this.dateDialog = !this.dateDialog
      } else {
        this.walletDialog = !this.walletDialog
        this.type = val
      }
    },
    /* 收支筛选 */
    filterType(obj) {
      var that = this;
      that.typeLabel = obj.label;
      that.fType = obj.val;
      var toDay = new Date();
      if (obj.val == 1) {
        //近6个月内的
      } else {
        //近6个月以前的
        toDay = new Date(that.maxStateDate);
      }
      var sDate = new Date(toDay.getTime() - 24 * 60 * 60 * 1000 * 30);//起始时间当天前30天
      var eDate = new Date(toDay.getTime());//结束时间为当天， - 24 * 60 * 60 * 1000(减24为昨天)
      that.date = [new Date(sDate), new Date(eDate)];//
      that.$refs.WDatePicker.date = [new Date(sDate), new Date(eDate)];
      that.$refs.WDatePicker.timeDefaultShow = toDay;
      this.$set(this.form, 'BeginDate', that.$store.getters.getDateTime("yyyy-MM-dd", sDate));
      this.$set(this.form, 'EndDate', that.$store.getters.getDateTime("yyyy-MM-dd", eDate));
      this.$set(this.form, 'PageIndex', 1);
      this.$set(this.form, 'PageSize', this.pageSizeMax);
      this.getData('','','GetRecordByPage');
    },
    /* 收支筛选 */
    filterList(obj) {
      //console.log("filterList", obj);
      var that = this;
      that.selectLabel = obj.label;
      this.$set(this.form, 'BusinessType', obj.val);
      this.$set(this.form, 'PageIndex', 1);
      this.$set(this.form, 'PageSize', this.pageSizeMax);
      this.getData('','','GetRecordByPage');

    },
    //关闭弹框
    closeDialog(data = {}) {
      this.walletDialog = false
      this.dateDialog = false
      if (data.type && data.type == 'getList') {
        //重新获取列表
        let { beginDate, endDate } = data;
        this.$set(this.form, 'PageIndex', 1);
        this.$set(this.form, 'PageSize', this.pageSizeMax);
        if (beginDate && endDate) {
          this.$set(this.form, 'BeginDate', beginDate);
          this.$set(this.form, 'EndDate', endDate);
        }
        this.getData('','','GetAccountInfo');
        this.getData('','','GetRecordByPage');
      }
    },

  }
}

</script>

<style scoped>
@import "./wallet.css";
</style>



// WEBPACK FOOTER //
// src/pages/wallet/index.vue